import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { App } from './App';
import { initializePublicClientApplication } from './app-stores/initialize-public-client-application';
import { RootStoresProvider } from './app-stores/root-store-provider';
import { redirectRequest } from './configurations';
import { ErrorPage } from './pages/page-error/ErrorPage';
import { ResponseOidcPage } from './pages/page-response-oidc/ResponseOidcPage';

const renderRoot = async () => {
  const msalInstance = await initializePublicClientApplication();

  const router = createBrowserRouter([
    {
      path: '/response-oidc',
      element: <ResponseOidcPage />,
      errorElement: <ErrorPage />,
    },
    {
      path: '*',
      element: (
        <MsalAuthenticationTemplate
          interactionType={InteractionType.Redirect}
          authenticationRequest={redirectRequest}
        >
          <App />
        </MsalAuthenticationTemplate>
      ),
      errorElement: <ErrorPage />,
    },
  ]);

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <MsalProvider instance={msalInstance}>
      <FluentProvider theme={webLightTheme}>
        <RootStoresProvider>
          <RouterProvider router={router} />
        </RootStoresProvider>
      </FluentProvider>
    </MsalProvider>
  );
};

renderRoot();